import { render, staticRenderFns } from "./supportingDocument.vue?vue&type=template&id=4a270ece&scoped=true"
import script from "./supportingDocument.vue?vue&type=script&lang=js"
export * from "./supportingDocument.vue?vue&type=script&lang=js"
import style0 from "./supportingDocument.vue?vue&type=style&index=0&id=4a270ece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a270ece",
  null
  
)

export default component.exports